import React from 'react';
import Timer from './Timer';
import QuestionDisplay from './QuestionDisplay';
import AnswerOptions from './AnswerOptions';
import './QuizScreen.css';

const QuizScreen = ({ 
  question, 
  questionNumber, 
  totalQuestions, 
  timeLeft, 
  onAnswer, 
  isAnswered, 
  userAnswers 
}) => {
  return (
    <div className="quiz-screen">
      <div className="fixed-info">
        <div className="question-info">
          <span className="question-counter">
            سؤال {questionNumber} من {totalQuestions}
          </span>
          <div className="progress-bar">
            <div 
              className="progress-fill" 
              style={{ width: `${(questionNumber / totalQuestions) * 100}%` }}
            ></div>
          </div>
        </div>
        <Timer timeLeft={timeLeft} />
      </div>
      
      <div className="screen-header">
        <div className="header-logos">
<img src="/saudi95.png" alt="شعار اليوم الوطني 95" className="national-logo" />          
<img src="/benchlogocropped.png" alt="شعار المقهى" className="cafe-logo" />
          
        </div>
      </div>

      <div className="quiz-content">
        <QuestionDisplay question={question} />
        <AnswerOptions 
          question={question}
          onAnswer={onAnswer}
          isAnswered={isAnswered}
        />
      </div>

      <div className="score-indicator">
        <span>الإجابات الصحيحة: {userAnswers.filter(a => a.isCorrect).length}</span>
        <span>الخصم الحالي: {Math.min(userAnswers.filter(a => a.isCorrect).length * 10, 50)}%</span>
      </div>
      
      <div className="footer-strap">
        <img src="/footerstrap.png" alt="شريط سفلي" className="footer-image" />
      </div>
    </div>
  );
};

export default QuizScreen;
